import { ArticleCardType } from "@/src/types";
import { Typography } from "@material-tailwind/react";
import React from "react";

import ArticleGridList from "../cards/ArticleGridList";
import Slash from "../accoutrements/slash";

export interface RelatedArticlesProps {
  articles: ArticleCardType[];
}

const RelatedArticles = ({ articles }: RelatedArticlesProps) => {
  return (
    <div className={"flex flex-col gap-4"}>
      <Typography variant="h5">
        <b>Related</b>
        <Slash />
      </Typography>
      <ArticleGridList articles={articles.slice(0, 4)} />
    </div>
  );
};

export default RelatedArticles;
